import React from 'react';

export default function AppMarkdownImage({ imgSrc, width }) {
  return (
    <div className='mb-4 flex items-center justify-center'>
      <img src={imgSrc} alt='' width={width ? width : '220px'} />
    </div>
  );
}
